// import 'normalize.css/normalize.css'
import './index.sass'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'

// import 'bootstrap/dist/js/bootstrap.min.js' // Parcel's broken

import 'babel-polyfill/dist/polyfill.min.js'

import reportError, { init as initError, status as reportStatus } from './error'

const searchEnginePromise = import('./searchEngine.js')
const mapPromise = import('./mapka.js')
const queryPromise = import('./apiQuery.js')

const TYPY = Object.freeze({
  '1': 'Jadro suburbanizace',
  '2': 'Suburbánní obec',
  '3': 'Obec s populačním ziskem',
  '4': 'Obec s populační ztrátou/stagnací'
})

function initDataInput (onSubmit) {
  document.getElementById('submit-btn').onclick = e => {
    e.preventDefault()
    const inputs = document.querySelectorAll('#data-input input')
    const res = {
      rd: {},
      bd: {}
    }
    inputs.forEach(el => {
      res[el.dataset.type][el.dataset.year] = el.value
    })
    onSubmit(res)
  }
}

window.addEventListener('load', async () => {
  initError()

  const searchEngine = await searchEnginePromise
  const map = await mapPromise

  const query = (await queryPromise).default

  let selected = null

  function onSelected (m) {
    selected = m

    const typ = map.findTypObce(m.i)

    document.getElementById('map-overlay').hidden = false
    document.getElementById('selected-name').innerText = `${m.n} (okres ${searchEngine.findOkres(m.o).n})`
    document.getElementById('selected-type').innerText = (typ !== null ? `${TYPY[typ]}` : '')
  }
  async function onSubmit (inputData) {
    try {
      if (!selected) {
        reportError(
          'Vyberte prosím obec v mapě nebo pomocí vyhledávacího pole.'
        )
        return
      }

      reportStatus('Probíhá výpočet')

      try {
        $('#warning-modal').modal()
      } catch (e) {
        console.error('Failed to display modal: ', e)
        // Chyba pri zobrazovani modalu neni duvodem k selhani kalkulacky
      }

      await query(selected, inputData)

      reportStatus()
    } catch (e) {
      reportError('Došlo k neznámé chybě. Kód chyby 796')
      console.error(e)
    }
  }

  searchEngine.init(onSelected)
  map.init(onSelected)
  initDataInput(onSubmit)

  document.getElementById('map-overlay-back').onclick = () => {
    selected = null
    document.getElementById('map-overlay').hidden = true
  }

  reportStatus()
})
